import React from "react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import api from "../api";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

export default function GoogleLoginButton({ onSuccess }) {
  if (!clientId) return null;
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          try {
            const idToken = credentialResponse.credential;
            const { data } = await api.post("/api/auth/google", { idToken });
            onSuccess?.(data);
          } catch (e) {
            alert("Google login failed");
          }
        }}
        onError={() => alert("Google login failed")}
      />
    </GoogleOAuthProvider>
  );
}
